import React, { useState } from "react";
import { LicenceSuspensionDetails } from "./LicencesSuspension/LicenceSuspensionDetails";
import { LicenceSuspensionTable } from "./LicencesSuspension/LicenceSuspensionTable";

export const LicenceSuspensionTab = (props) => {
    const { appData } = props;
    const { licenceSuspendedData } = appData

    const [criminalHistoryItem, setCriminalHistoryItem] = useState()

    return criminalHistoryItem 
    ? <LicenceSuspensionDetails criminalHistoryItem={criminalHistoryItem} setCriminalHistoryItem={setCriminalHistoryItem} />
    : <LicenceSuspensionTable licenceSuspendedData={licenceSuspendedData} setCriminalHistoryItem={setCriminalHistoryItem} />
}
